module.exports = __webpack_public_path__ + "static/img/guide-10.729ba749.png";